module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ga-Ha-Id-Ja.d59a4a9f.png";